import { Badge, Button, Container, Flex, Heading, ScrollArea, Text } from "@radix-ui/themes";
import useFetch from '../../core/hooks/useFetch'
import { useEffect, useState } from "react";
import {IContract} from '../../core/types/services-types/contract-types'
import ContractService from '../../core/services/ContractService'
import { Link, useNavigate } from "react-router";
import { ROUTES } from "../../routes/constants";
import Pagination from "../../components/common/renders/pagination-render";

export default function UploadedDocuments() {

    const [contracts, setContracts] = useState<IContract[]>([])
    const [limit, setLimit] = useState<number>(100)
    const [page, setPage] = useState<number>(0)
    const [totalCount, setTotalCount] = useState<number>(0)
    const [fetchContracts, isLoading, error, errors] = useFetch(async () => {
        const data = await ContractService.GetAll(limit, page)
        setContracts(data.rows)
        setTotalCount(data.count)
    })

    const navigate = useNavigate()

    useEffect(() =>  {
        fetchContracts()
    }, [])

    return (
        <Container className="uploaded-documents p-5 pt-10 bg-zinc-100 h-[100vh]">

            <Container className="mb-10 shadow-lg p-5 rounded-lg bg-zinc-50"> 
            <Container className="heading-uploaded-documents">
                <Heading>
                    Загруженные документы/Договора/Соглашения
                </Heading>
            </Container>
            <hr />

            <ScrollArea type="scroll" className="mt-5 max-h-[630px]">
                {contracts.map(item => {
                    return (
                           <Flex align={'center'} justify={'between'} className="mb-5">
                            <Flex direction={'column'}>
                           <Text>{item.id}.{item.title}</Text>
                            <Text>Пользователь: <Link to={`/profile/${item.user.id}`}>{item.user.login}</Link></Text>
                            </Flex>
                            <Flex gap={'3'} align={'center'} justify={'end'}> 
                            <Button onClick={() => navigate(`${ROUTES.UPLOADED_DOCUMENT_ROUTE}/${item.id}`)}>Открыть</Button>
                             <Badge color={item.status === 'В обработке' ? 'orange' : item.status === 'Пройдено' ? 'grass' : 'red'}>{item.status}</Badge>
                            </Flex>
                         </Flex>
                    )
                })}
            </ScrollArea>
                  <Pagination total={totalCount} count={limit} activeIndex={page} onChangeIndex={setPage}  />
            </Container>

        </Container>
    )
}